import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import styled from 'styled-components'

const TeamLogo = styled.div`
  width: auto;
  max-height: 100%;
`

const TeamImage = props => (
  <StaticQuery
    query={graphql`
      query {
        EPLImage: file(relativePath: { eq: "league/epl-logo.png" }) {
          childImageSharp {
            fluid(maxWidth: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        LaLigaImage: file(relativePath: { eq: "league/la-liga-logo.png" }) {
          childImageSharp {
            fluid(maxWidth: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        SerieAImage: file(relativePath: { eq: "league/serie-a-logo.png" }) {
          childImageSharp {
            fluid(maxWidth: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        MLSImage: file(relativePath: { eq: "league/mls-logo.png" }) {
          childImageSharp {
            fluid(maxWidth: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        MLBImage: file(relativePath: { eq: "league/mlb-logo.png" }) {
          childImageSharp {
            fluid(maxWidth: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        AFLImage: file(relativePath: { eq: "league/afl-logo.png" }) {
          childImageSharp {
            fluid(maxWidth: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        NFLImage: file(relativePath: { eq: "league/nfl-logo.png" }) {
          childImageSharp {
            fluid(maxWidth: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        NBAImage: file(relativePath: { eq: "league/nba-logo.png" }) {
          childImageSharp {
            fluid(maxWidth: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        PhiladelphiaImage: file(relativePath: { eq: "teams/76ers_logo.png" }) {
          childImageSharp {
            fluid(maxWidth: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        BostonCelticsImage: file(
          relativePath: { eq: "teams/Celtics_logo.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        PortlandTimbersImage: file(
          relativePath: { eq: "teams/portland-timbers_logo.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        OrlandoCityImage: file(
          relativePath: { eq: "teams/orlando-city_logo.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        FcCincinnatiImage: file(
          relativePath: { eq: "teams/fc-cincinnati_logo.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        DcUtdImage: file(relativePath: { eq: "teams/dc-united_logo.png" }) {
          childImageSharp {
            fluid(maxWidth: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        LaGalaxyImage: file(relativePath: { eq: "teams/la-galaxy_logo.png" }) {
          childImageSharp {
            fluid(maxWidth: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        LosAngelesImage: file(
          relativePath: { eq: "teams/los-angeles_logo.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        NewYorkCityImage: file(
          relativePath: { eq: "teams/new-york-city_logo.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        KansasCityImage: file(
          relativePath: { eq: "teams/kansas-city_logo.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        TorontoFCImage: file(relativePath: { eq: "teams/toronto_logo.png" }) {
          childImageSharp {
            fluid(maxWidth: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        HoustonDynamoImage: file(
          relativePath: { eq: "teams/houston-dynamo_logo.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        SouthamptonImage: file(
          relativePath: { eq: "teams/southampton_logo.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        JordanGillImage: file(
          relativePath: { eq: "teams/jordan-gill_photo.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        YesnerTalaveraImage: file(
          relativePath: { eq: "teams/yesner-talavera_photo.png" }
        ) {
          childImageSharp {
            fluid(maxWidth: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        noImage: file(relativePath: { eq: "teams/no-logo.png" }) {
          childImageSharp {
            fluid(maxWidth: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={data => {
      const { teamname } = props

      if (teamname === 'la-liga') {
        return (
          <TeamLogo>
            <Img
              fluid={data.LaLigaImage.childImageSharp.fluid}
              alt={teamname}
            />
          </TeamLogo>
        )
      }
      if (teamname === 'serie-a') {
        return (
          <TeamLogo>
            <Img
              fluid={data.SerieAImage.childImageSharp.fluid}
              alt={teamname}
            />
          </TeamLogo>
        )
      }
      if (teamname === 'epl') {
        return (
          <TeamLogo>
            <Img fluid={data.EPLImage.childImageSharp.fluid} alt={teamname} />
          </TeamLogo>
        )
      }
      if (teamname === 'mlb') {
        return (
          <TeamLogo>
            <Img fluid={data.MLBImage.childImageSharp.fluid} alt={teamname} />
          </TeamLogo>
        )
      }
      if (teamname === 'mls') {
        return (
          <TeamLogo>
            <Img fluid={data.MLSImage.childImageSharp.fluid} alt={teamname} />
          </TeamLogo>
        )
      }
      if (teamname === 'nba') {
        return (
          <TeamLogo>
            <Img fluid={data.NBAImage.childImageSharp.fluid} alt={teamname} />
          </TeamLogo>
        )
      }
      if (teamname === 'nfl') {
        return (
          <TeamLogo>
            <Img fluid={data.NFLImage.childImageSharp.fluid} alt={teamname} />
          </TeamLogo>
        )
      }
      if (teamname === 'afl') {
        return (
          <TeamLogo>
            <Img fluid={data.AFLImage.childImageSharp.fluid} alt={teamname} />
          </TeamLogo>
        )
      }
      if (teamname === 'Philadelphia 76ers') {
        return (
          <TeamLogo>
            <Img
              fluid={data.PhiladelphiaImage.childImageSharp.fluid}
              alt={teamname}
            />
          </TeamLogo>
        )
      }
      if (teamname === 'Boston Celtics') {
        return (
          <TeamLogo>
            <Img
              fluid={data.BostonCelticsImage.childImageSharp.fluid}
              alt={teamname}
            />
          </TeamLogo>
        )
      }
      if (teamname === 'Portland Timbers') {
        return (
          <TeamLogo>
            <Img
              fluid={data.PortlandTimbersImage.childImageSharp.fluid}
              alt={teamname}
            />
          </TeamLogo>
        )
      }
      if (teamname === 'Orlando City') {
        return (
          <TeamLogo>
            <Img
              fluid={data.OrlandoCityImage.childImageSharp.fluid}
              alt={teamname}
            />
          </TeamLogo>
        )
      }
      if (teamname === 'Fc Cincinnati') {
        return (
          <TeamLogo>
            <Img
              fluid={data.FcCincinnatiImage.childImageSharp.fluid}
              alt={teamname}
            />
          </TeamLogo>
        )
      }
      if (teamname === 'DC Utd') {
        return (
          <TeamLogo>
            <Img fluid={data.DcUtdImage.childImageSharp.fluid} alt={teamname} />
          </TeamLogo>
        )
      }
      if (teamname === 'LA Galaxy') {
        return (
          <TeamLogo>
            <Img
              fluid={data.LaGalaxyImage.childImageSharp.fluid}
              alt={teamname}
            />
          </TeamLogo>
        )
      }
      if (teamname === 'Los Angeles Fc') {
        return (
          <TeamLogo>
            <Img
              fluid={data.LosAngelesImage.childImageSharp.fluid}
              alt={teamname}
            />
          </TeamLogo>
        )
      }
      if (teamname === 'New York City') {
        return (
          <TeamLogo>
            <Img
              fluid={data.NewYorkCityImage.childImageSharp.fluid}
              alt={teamname}
            />
          </TeamLogo>
        )
      }
      if (teamname === 'Kansas City') {
        return (
          <TeamLogo>
            <Img
              fluid={data.KansasCityImage.childImageSharp.fluid}
              alt={teamname}
            />
          </TeamLogo>
        )
      }
      if (teamname === 'Toronto Fc') {
        return (
          <TeamLogo>
            <Img
              fluid={data.TorontoFCImage.childImageSharp.fluid}
              alt={teamname}
            />
          </TeamLogo>
        )
      }
      if (teamname === 'Houston Dynamo') {
        return (
          <TeamLogo>
            <Img
              fluid={data.HoustonDynamoImage.childImageSharp.fluid}
              alt={teamname}
            />
          </TeamLogo>
        )
      }
      if (teamname === 'Southampton') {
        return (
          <TeamLogo>
            <Img
              fluid={data.SouthamptonImage.childImageSharp.fluid}
              alt={teamname}
            />
          </TeamLogo>
        )
      }
      if (teamname === 'Jordan Gill') {
        return (
          <TeamLogo>
            <Img
              fluid={data.JordanGillImage.childImageSharp.fluid}
              alt={teamname}
            />
          </TeamLogo>
        )
      }
      if (teamname === 'Yesner Talavera') {
        return (
          <TeamLogo>
            <Img
              fluid={data.YesnerTalaveraImage.childImageSharp.fluid}
              alt={teamname}
            />
          </TeamLogo>
        )
      }
      return (
        <TeamLogo>
          <Img fluid={data.noImage.childImageSharp.fluid} alt="" />
        </TeamLogo>
      )
    }}
  />
)

TeamImage.propTypes = {
  teamname: PropTypes.any,
}

export default TeamImage
